// extracted by mini-css-extract-plugin
export default {"header":"style_header__bvpcU","label":"style_label__wV7RN","popup":"style_popup__QD66Y"};